import React, {useState} from 'react';
import {Col, Nav, Row, Tab} from 'react-bootstrap';

const VerticalTabs = ({config}) => {
    const [activeKey, setActiveKey] = useState(config.defaultActiveKey);


    return (
        <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
            <Row className={"mt-5"}>
                <Col sm={3}>
                    <Nav variant="pills" className="flex-column">
                        {config.tabs.map((tab) => (
                            <Nav.Item key={tab.key}>
                                <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                            </Nav.Item>
                        ))}
                    </Nav>
                </Col>
                <Col sm={9}>
                    <Tab.Content>
                        {config.tabs.map((tab) => (
                            <Tab.Pane eventKey={tab.key} key={tab.key}>
                                <Row>
                                    <Col>
                                        <h4>{tab.label}</h4>
                                    </Col>
                                </Row>
                                <Row className={"mt-2"}>
                                    {tab.content}
                                </Row>
                            </Tab.Pane>
                        ))}
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    );
};

export default VerticalTabs;
